import React, { PureComponent } from 'react'
import { VictoryChart, VictoryBar, VictoryZoomContainer, VictoryAxis } from 'victory'
import theme from './theme'

class BarChart extends PureComponent {
  render () {
    const {
      data,
      x,
      y,
      zoomDomain,
      handleZoom,
      chartStyles,
      datetime
    } = this.props

    return (
      <VictoryChart
        height={200}
        theme={theme}
        padding={{ top: 5, bottom: 40, left: 40, right: 20 }}
        domain={zoomDomain}
        scale={{ x: 'time' }}
        style={{
          parent: {}
        }}
        responsive={false}
        >
        <VictoryAxis dependentAxis />
        <VictoryAxis scale={{ x: 'time' }} />
        <VictoryBar
          data={data}
          x={x}
          y={y}
          style={chartStyles ? chartStyles(datetime).bar : null}
        />
      </VictoryChart>
    )
  }
}

export default BarChart



// WEBPACK FOOTER //
// ./src/charts/ZoomBarChart.js